<template>
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 1C7.59489 1 5.64516 3.03766 5.64516 5.55123C5.64516 8.06481 7.59489 10.1025 10 10.1025C12.4051 10.1025 14.3548 8.06481 14.3548 5.55123C14.3548 3.03766 12.4051 1 10 1Z" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.35484 12.5298C2.94973 12.5298 1 14.5674 1 17.081V18.5232C1 19.4374 1.63393 20.2168 2.49722 20.3641C7.46618 21.212 12.5338 21.212 17.5028 20.3641C18.3661 20.2168 19 19.4374 19 18.5232V17.081C19 14.5674 17.0503 12.5298 14.6452 12.5298H14.2493C14.0351 12.5298 13.8222 12.5652 13.6185 12.6347L12.6134 12.9777C10.9152 13.5572 9.08475 13.5572 7.38662 12.9777L6.3815 12.6347C6.17784 12.5652 5.96494 12.5298 5.75069 12.5298H5.35484Z" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "ProfileIcon"
    }
</script>

<style scoped>

</style>